import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHero } from "@/components/site/SiteLayout";
import { FEATURES } from "@/data/features";

export const FeaturesIndex = () => (
  <div data-testid="features-page">
    <PageHero eyebrow="Features" title="Everything you need to manage your team's time." intro="Six tools that work together, so attendance, rosters and pay all line up." />
    <section className="mx-auto grid max-w-7xl gap-5 px-4 py-16 sm:px-6 md:grid-cols-2 lg:grid-cols-3 lg:px-8">
      {Object.entries(FEATURES).map(([key, f]) => {
        const Icon = f.icon;
        return (
          <Link key={key} to={`/${key}`} className="group rounded-2xl border border-slate-200 p-7 transition-shadow hover:shadow-lg" data-testid={`features-link-${key}`}>
            <Icon className="h-6 w-6 text-[#00A85C]" />
            <h2 className="mt-4 text-lg font-semibold">{f.title}</h2>
            <p className="mt-2 text-sm text-slate-600">{f.intro}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#00A85C]">Learn more <ArrowRight className="h-4 w-4" /></span>
          </Link>
        );
      })}
    </section>
  </div>
);

export default function FeaturePage({ slug }) {
  const f = FEATURES[slug];
  const Icon = f.icon;
  return (
    <div data-testid={`feature-page-${slug}`}>
      <PageHero eyebrow={f.eyebrow} title={f.title} intro={f.intro}>
        <div className="mt-8 flex gap-3">
          <Link to="/register"><Button className="rounded-full bg-[#00C16B] hover:bg-[#00A85C]" data-testid="feature-register-btn">Start free trial</Button></Link>
          <Link to="/pricing"><Button variant="outline" className="rounded-full" data-testid="feature-pricing-btn">Pricing</Button></Link>
        </div>
      </PageHero>
      <section className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 lg:grid-cols-12 lg:px-8">
        <div className="lg:col-span-4"><div className="grid h-20 w-20 place-items-center rounded-3xl bg-emerald-50"><Icon className="h-9 w-9 text-[#00A85C]" /></div></div>
        <div className="grid gap-6 sm:grid-cols-2 lg:col-span-8">
          {f.points.map(([t, d]) => (
            <div key={t} className="rounded-2xl border border-slate-200 p-6">
              <Check className="h-5 w-5 text-[#E07800]" />
              <h3 className="mt-3 font-semibold">{t}</h3>
              <p className="mt-1 text-sm text-slate-600">{d}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
